













































































































import {
  DrivewealthAccountManagementType,
  DrivewealthAccountSummary,
  FetchState,
  InstrumentDetail,
  InstrumentPerformanceData,
  InstrumentStatus
} from "@/shared/types";
import { Component, Prop, Vue } from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import AccountTypeSubheader from "@/employee/components/investments/drivewealth/AccountTypeSubheader.vue";
import DrivewealthNavigation from "@/shared/components/investments/drivewealth/DrivewealthNavigation.vue";
import InstrumentPerformanceGraph from "@/shared/components/investments/drivewealth/InstrumentPerformanceGraph.vue";
import { formatCurrency } from "@/shared/currency";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useInstrumentPerformanceDataStore } from "@/shared/store/instrumentPerformanceData";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useDrivewealthSweepStore } from "@/shared/store/drivewealthSweep";
import { useUserStore } from "@/shared/store/user";
import * as RouteNames from "@/employee/route-names";
import _ from "lodash";
import moment from "moment-timezone";

@Component({  computed: {
    FetchState () {
      return FetchState;
    },
  },
  components: {
    GenericLoadingSpinner,
    InstrumentPerformanceGraph,
    DrivewealthNavigation,
    AccountTypeSubheader
  }
})
export default class InstrumentPerformanceView extends Vue {
  @Prop({ required: false }) username: string;
  @Prop({ required: false }) partnerId: number;
  @Prop() symbol: string;
  @Prop() accountId: number;

  instrumentPerformanceDataStore = useInstrumentPerformanceDataStore();
  drivewealthStore = useDrivewealthStore();
  featureFlagStore = useFeatureFlagStore();
  drivewealthSweepStore = useDrivewealthSweepStore();
  userStore = useUserStore();

  formatCurrency = formatCurrency;
  RouteNames = RouteNames;

  displayReviewAutoFundingMessage = false;

  created (): void {
    this.instrumentPerformanceDataStore.getInstrumentPerformanceData(this.symbol);
    this.drivewealthStore.getAccountSummaryV2({
      username: this.username, partnerId: this.partnerId, dwAccountId: this.accountId
    });
    this.drivewealthSweepStore.getSweepV2({});
    this.drivewealthStore.loadInstrumentData(this.symbol, this.accountId,
        { username: this.username, partnerId: this.partnerId });
  }

  get isLoaded (): boolean {
    return this.instrumentPerformanceData &&
        this.instrumentPerformanceData.fetchState === FetchState.Loaded &&
        this.drivewealthStore.instrumentDataIsLoaded(this.symbol);
  }

  addToAutoFunding (): void {
    this.drivewealthSweepStore.sweepAddInstrument({accountId: this.accountId, stockSymbol: this.symbol});
    this.displayReviewAutoFundingMessage = true;
  }

  get accountSummaryV2 (): DrivewealthAccountSummary {
    return this.drivewealthStore.accountSummaryById(this.accountId);
  }

  routeParams (symbol: string): { symbol: string, accountId?: number, partnerId?: number } {
    if (this.accountId) {
      return { symbol, accountId: this.accountId, partnerId: this.partnerId };
    }

    return { symbol, partnerId: this.partnerId };
  }

  isPositiveNumber (value: number): boolean {
    return value >= 0;
  }

  formatDisplayFiniteValue (value: number): string {
    if (_.isFinite(value)) {
      return `${value.toFixed(2)}%`;
    }

    return "N/A";
  }

  get isEmployerPortal (): boolean {
    return this.userStore.isEmployerPortal;
  }

  get employerPortalSellInstrumentEnabled (): boolean {
    return this.featureFlagStore.flags.bend23519EnablePartnerInvestmentInstrumentAllowSell &&
        this.isEmployerPortal;
  }

  get canBuySell (): boolean {
    return (this.employerPortalSellInstrumentEnabled || !this.username) &&
        !this.drivewealthStore.isAccountManagementType(DrivewealthAccountManagementType.RiaManaged, this.accountId);
  }

  get instrumentDetail (): InstrumentDetail {
    return this.drivewealthStore.instrumentDetailBySymbol(this.symbol);
  }

  get canBuyThisInstrument (): boolean {
    return this.instrumentDetail && this.instrumentDetail.status === InstrumentStatus.Active;
  }

  get canSellThisInstrument (): boolean {
    if (!this.accountSummaryV2) {
      return false;
    }

    const holding = _.find(this.accountSummaryV2.holdings, x => x.stockSymbol === this.symbol);
    return !!holding;
  }

  get canAddToAutoFunding (): boolean {
    if (!this.accountSummaryV2 || !this.drivewealthSweepStore.sweepLoaded) {
      return false;
    }

    const holdingExistsInSweepFunds = _.find(this.drivewealthSweepStore.sweepFunds, x => x.symbol === this.symbol);
    return this.canBuyThisInstrument &&
        !holdingExistsInSweepFunds;
  }

  get isLoading (): boolean {
    return !this.instrumentPerformanceData ||
        this.instrumentPerformanceData.fetchState === FetchState.Loading;
  }

  get instrumentPerformanceData (): InstrumentPerformanceData {
    return this.instrumentPerformanceDataStore.instrumentPerformanceData(this.symbol);
  }

  get formattedCloseDate (): string {
    if (this.instrumentPerformanceData) {
      return moment.tz(this.instrumentPerformanceData.closeDateTime, "America/New_York")
          .format("h:mm:ss A zz, MM/DD/YYYY");
    }

    return "";
  }
}
